<main>
  <p class="header">Uwaga!</p>
  <p class="msg">
    Sesja wygasła. <br />
    Ponownie zaloguj się na swoje konto.
  </p>
  <button (click)="logout()">OK</button>
</main>
